module.exports = __webpack_public_path__ + "media/images/navbar_text-7db21f420d7bac608ea3177e0e9afe61.png";